/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/EmailConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const EmailConfigCardTestIds = {
  btnCreateEmailConfig: "btn-create-email-config",
  btnEditEmailConfig: "btn-edit-email-config",
  cardTitleEmailConfig: "card-title-email-config",
  emailConfigCard: "email-config-card",
  emailNotConfigured: "email-not-configured",
  selectBodyContentType: "select-body-content-type"
} as const;
